import { useGetCompaniesQuery, useGetCompanyQuery } from '../api/companies';

export function useGetCompanies() {
    return useGetCompaniesQuery(undefined, {
        selectFromResult: ({ data, ...rest }) => {
            return {
                ...rest,
                companies: data ? data : [],
            };
        },
    });
}

export function useGetCompany(companyIdentifier: string | undefined) {
    return useGetCompanyQuery(String(companyIdentifier), {
        skip: !companyIdentifier,
        selectFromResult: ({ data, ...rest }) => {
            return {
                ...rest,
                company: data,
            };
        },
    });
}
